import log from '@vcclive/log';
import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import { reportReducerError } from './errorReporter';
import { ReducerObjectMapObject, Action, ReducerObject } from '../interfaces/redux';

const debug = log.getDebug('redux');

export function mixReducers<S>(reducers: ReducerObjectMapObject<any>): Reducer<S> {
    const result: ReducersMapObject = {};
    let reducer;
    Object.keys(reducers).forEach((key) => {
        reducer = reducers[key];
        if (typeof reducer === 'function') {
            result[key] = reducer;
        } else {
            result[key] = reduce.bind(null, key, reducer);
        }
    });
    return combineReducers<S>(reportReducerError(result));
}

function reduce<S>(reducerName: string, reducerObject: ReducerObject<S>, stateOrEmpty: S | undefined, action: Action) {
    let state = stateOrEmpty;
    if (typeof state === 'undefined') {
        debug(`init: ${reducerName}`, `in action: ${action.type}`);
        state = reducerObject.initState();
    }
    if (action.type in reducerObject) {
        return reducerObject[action.type](state, action);
    }
    return state;
}
